import * as Sentry from '@sentry/browser';

function getEnvironmentFromUrl(): 'staging' | 'production' | 'review' {
  if (window.location.host.indexOf('staging') > -1) {
    return 'staging';
  }

  return 'production';
}

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    release: `evp-web-fe@${process.env.REACT_APP_VERSION}`,
    environment: getEnvironmentFromUrl(),
    dsn: 'https://2a5f6e46437f479dbcde87107198aaca@sentry.komp.family/2',
  });
}
